import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Preloader from '../../components/common/Preloader';
import { isDetailsPending } from '../../modules/account/selectors';
import Translation from '../i18n/Translation';
import { viewEnter } from './actions';

export const withOmni = (WrappedComponent) => {
  class OmniWrapper extends Component {
    constructor() {
      super();
      this.state = {
        checkingState: true
      };
    }

    componentWillMount() {
      this.props.viewEnter();
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.checkingState !== nextProps.checkingState) {
        this.setState({
          checkingState: nextProps.checkingState
        });
      }
    }

    render() {
      const { checkingState } = this.state;

      return (checkingState) ? (
        <div className="with-omni">
          <div className="with-omni__preloader">
            <Preloader>
              <Translation section="linkingAccounts" label="checking" />
            </Preloader>
          </div>
        </div>
      ) : (<WrappedComponent />);
    }
  }

  OmniWrapper.propTypes = {
    viewEnter: PropTypes.func.isRequired,
    checkingState: PropTypes.bool
  };

  return OmniWrapper;
};

const mapStateToProps = state => ({
  checkingState: isDetailsPending(state)
});

const mapDispatchToProps = {
  viewEnter
};

export default (wrappedComponent) => (
  connect(mapStateToProps, mapDispatchToProps)(withOmni(wrappedComponent))
);
